// validation constants from https://redux-form.com/7.1.2/examples/fieldlevelvalidation/

export const required = value => (value ? undefined : 'Required');
export const minLength = min => value =>
    value && value.length < min ? `Must be ${min} characters or more` : undefined;
export const minLength2 = minLength(2)
export const minLength12 = minLength(12)
export const alphaNumeric = value => value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined;
export const alphaNumericPlus = value =>
   value && /[^a-zA-Z0-9\d-_,.'/!?#&: ]/i.test(value)
      ? 'Alphanumeric characters and .,!?-_\'/#&: only'
      : undefined;
export const phoneNumber = value =>
    value && !/^(0|[1-9][0-9]{9})$/i.test(value)
        ? 'Invalid phone number, must be 10 digits'
        : undefined;


// WEBPACK FOOTER //
// ./src/constants/ValidationRules.js